import { createFileRoute } from "@tanstack/react-router";

import { HomePage } from "@/components/HomePage";

const SITE_URL = "https://prank-reboot-studio.lovable.app";

export const Route = createFileRoute("/fb1")({
  head: () => ({
    meta: [
      { title: "Real Pranks — A New Drop Every Week" },
      {
        name: "description",
        content:
          "For a limited time, subscribe and get immediate access to 3 videos. Stay subscribed to gain access to a new video each week.",
      },
      { property: "og:title", content: "Real Pranks — Weekly Drops" },
      {
        property: "og:description",
        content:
          "For a limited time, subscribe and get immediate access to 3 videos. Stay subscribed to gain access to a new video each week.",
      },
      { property: "og:url", content: `${SITE_URL}/fb1` },
      { property: "og:image", content: `${SITE_URL}/og-image.png` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: `${SITE_URL}/og-image.png` },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/fb1` }],
  }),
  component: Fb1Page,
});

function Fb1Page() {
  return <HomePage />;
}
